// file: src/routes/TowingRoutes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../Towingpages/Login.jsx";
import Dashboard from "../TowingDashboard/DashboardLayout.jsx";
import Logout from "../TowingDashboard/Logout.jsx";
import ForgotRequest from "../Towingpages/ForgotRequest.jsx";
import ResetPassword from "../Towingpages/ResetPassword.jsx";
import ProtectedRoute from "../components/routing/ProtectedRoute.jsx";

export default function TowingRoutes() {
  return (
    <Routes>
      {/* Public */}
      <Route path="login" element={<Login />} />
      <Route path="forgot" element={<ForgotRequest />} />
      <Route path="reset-password" element={<ResetPassword />} />

      {/* Protected */}
      <Route
        path="dashboard"
        element={
          <ProtectedRoute redirectTo="/towing/login">
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="dashboard/overview"
        element={<Navigate to="/towing/dashboard" replace />}
      />

      <Route path="logout" element={<Logout />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/towing/login" replace />} />
    </Routes>
  );
}
